/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import maticQuestions from 'images/coin-pages/questions/matic.svg'

import { commonSlidesData } from '../commonPageData'

export const maticPage: ICoinPageData = {
  title: 'coin_679',
  description: 'coin_680',
  // description: 'coin_681',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Polygon (MATIC)' }) }}
    />
  ),
  questionsBlock: {
    image: maticQuestions,
    questions: [
      {
        title: 'coin_682',
        answer: 'coin_683',
      },
      {
        title: 'coin_684',
        answer: 'coin_685',
      },
      {
        title: 'coin_686',
        answer: 'coin_687',
      },
      {
        title: 'coin_688',
        answer: 'coin_689',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Maker (MKR)'),
    text: [],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/borrow-like-a-pro/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_3200/https://coinrabbit.io/blog/wp-content/uploads/2022/06/Ltt.png',
        imageAlt: 'Crypto Loans: Tips and Tricks',
      },
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'What Is Crypto Lending and How Does It Work?',
      },
      {
        link: 'https://coinrabbit.io/blog/what-types-of-crypto-loans-are-there-and-how-can-i-profit-from-it/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/12/1.png',
        imageAlt: 'What types of crypto loans are there and how can I profit from it?',
      },
    ],
    paragraphs: [
      {
        title: 'coin_690',
        text: ['coin_692'],
      },
      {
        title: 'coin_691',
        text: ['coin_693'],
      },
    ],
  },
}
